<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" :id="id">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-body" v-if="book">
                    <button type="button" class="close-overlay" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <book-card :book="book" :favorite="false" :author="true" :footer="false"></book-card>
                    <div class="slider">
                        <div class="slider-item b-outline" v-for="o in outlines" :key="o.id">
                            <a :href="episodeLink(o)" class="stretched-link text-reset no-hover" target="_blank">
                                <img :src="o.picture.thumb_url + '?hash=' + o.picture.hash" class="episode-bg" v-if="o.picture">
                                <div class="episode-number">
                                    エピソード{{o.section.episode_number}}
                                </div>
                                <div class="episode-title mincho">
                                    {{o.section.section_name}}
                                </div>
                                <div class="synopsis mincho" v-html="synopsis(o)"></div>
                                <div class="episode-chars">
                                    {{ $filters.numberFormat(o.section.characters) }} 文字
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="sp-footer">
                        <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">
                            <i class="fas fa-times"></i>
                            閉じる
                        </button>
                        <div>
                            <a :href="bookLink" class="btn btn-outline-primary" target="_blank">
                                <i class="fas fa-book-open"></i>
                                読む
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <headline :book="book" :init="init"></headline>
    </div>
</template>

<style scoped lang="scss">
.modal-open .modal {
    backdrop-filter: blur(25px);
}
.modal-body {
    padding: 0;
    .card {
        margin-bottom: 0 !important;
    }
}
.modal-content {
    border: 0;
}
.close-overlay {
    position: absolute;
    top: .5rem;
    right: .5rem;
    font-size: 2.5rem;
    z-index: 1;
    border-radius: .5rem;
    border: 0;
    line-height: 1;
    color: #456a;
    background-color: #fff3;
}
.sp-footer {
    display: none;
}
.no-hover {
    &:hover {
        text-decoration: none;
    }
}
.slider {
    display: flex;
    overflow: scroll;
    margin: 0 15px;
    -ms-overflow-style: none;
    scrollbar-width: none;
    margin: 2rem 0;
    position: absolute;
    top: 295px;
    width: 100%;
    justify-content: center;
    pointer-events: none;
    flex-wrap: wrap;
    &::-webkit-scrollbar {
        display:none;
    }
    .slider-item {
        width: 210px;
        padding: 10px 15px 35px;
        border-radius: .5rem;
        margin: 1rem;
        position: relative;
        overflow: hidden;
        .episode-bg {
            pointer-events: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 210px;
            height: 333px;
            opacity: 0.15;
            object-fit: cover;
        }
        .episode-number {
            font-size: 0.7rem;
        }
        .episode-title {
            font-size: 1rem;
            margin: .5rem 0;
        }
        .synopsis {
            letter-spacing: 0.05rem;
            font-size: 0.7rem;
        }
        .episode-chars {
            font-size: 0.7rem;
            text-align: right;
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            padding: 0 1rem 0.5rem;
        }
    }
}
@media (max-width: 1140px) {
    .sp-footer {
        display: flex;
        padding: 1rem;
        justify-content: space-evenly;
    }
    .slider {
        position: relative;
        top: 0;
    }
}

</style>

<script>
import bookCard from '../author/bookCard.vue';
import headline from '../headline.vue';
export default {
    components: {
        bookCard,
        headline,
    },
    props: {
        id: {
            default: 'novel-description'
        },
        book: {
            default: null,
        },
    },
    data() {
        return {
            outlines: [],
            init: false,
        }
    },
    methods: {
        load() {
            if (!this.book.is_long) return;
            axios.get("/author/outlines/get", {params: {id: this.book.id}}).then(res => {
                this.outlines = res.data;
                if (!this.outlines.length) {
                    setTimeout(() => {
                        this.init = true;
                    }, 150);
                }
            }).catch(err => { alert.err(err.response) });
        },
        episodeLink(o) {
            let url = "";
            let subdomain = "www";
            if (this.book.author && this.book.author.subdomain) {
                subdomain = this.book.author.subdomain.toLowerCase();
            }
            if (subdomain + this.$store.state.base_domain !== location.hostname) {
                // ドメイン判定
                url = `//${subdomain}${this.$store.state.base_domain}`;
            }

            url += `/author/page/${this.book.id}/section/${o.section.id}`;
            return url;
        },
        synopsis(o) {
            return this.$filters.ruby(this.$filters.truncate(o.synopsis || o.section.body.replace(/<i\d+\|\d+>/ug, '').trim(), 140));
        }
    },
    computed: {
        bookLink() {
            let url = "";
            let subdomain = "www";
            if (this.book.author && this.book.author.subdomain) {
                subdomain = this.book.author.subdomain.toLowerCase();
            }
            if (subdomain + this.$store.state.base_domain !== location.hostname) {
                // ドメイン判定
                url = `//${subdomain}${this.$store.state.base_domain}`;
            }

            if (this.book.is_long) {
                // 長編
                url += `/author/book/${this.book.id}`;
            } else {
                // 短編
                url += `/author/page/${this.book.id}/section/${this.book.sections[0].id}`;
            }
            return url;
        }
    },
    mounted() {
        $("#" + this.id).on("show.bs.modal", (e) => {
            this.load();
        });
        $("#" + this.id).on("hide.bs.modal", (e) => {
            this.outlines = [];
            this.init = false;
        });
    },
    unmounted() {
        $("#" + this.id).modal("hide");
    }
}
</script>